<header [ngClass]="{'open': isMenuOpen, 'shadow': isScrolledToDown}">
  <app-navigation></app-navigation>
  <app-logo></app-logo>
  <app-app-store *ngIf="isIOS"></app-app-store>
  <app-play-market *ngIf="!isIOS"></app-play-market>
</header>
